import { WEEKLY_COLUMN_WIDTH } from "./weeklyEACColumns";

// Other Direct Costs (ODC) fixed (non-scrollable) columns — identifies each ODC record. No
// Detailed View precedent maps cleanly onto these labels, so they're sized to fit their content
// rather than lifted from detailedViewWidths.otherDirectCosts. CLIN's width (180) matches the one
// added to DIRECT_LABOR_FIXED_COLUMNS (weeklyEACColumns.js) so both tables' fixed-column totals
// stay equal and their scrollable weekly columns keep lining up.
export const ODC_FIXED_COLUMNS = [
  { label: "CLIN", accessor: (odc) => odc.clin, width: 180 },
  { label: "Expense Type", accessor: (odc) => odc.expenseType, width: 140 },
  { label: "Account", accessor: (odc) => odc.acctId, width: 100 },
  { label: "Account Name", accessor: (odc) => odc.acctName, width: 230 },
];

export const ODC_FIXED_TOTAL_WIDTH = ODC_FIXED_COLUMNS.reduce(
  (total, column) => total + column.width,
  0,
);

const odcBillableLabel = (odc) => (odc.billingStatus ? "Billable" : "Unbillable");
const odcYesNoLabel = (value) => (value ? "Yes" : "No");

// Static scrollable columns — display-only (plain text, no dropdowns), unlike Direct Labor's.
export const ODC_STATIC_COLUMNS = [
  { label: "Billable / Unbillable", accessor: odcBillableLabel, width: 130 },
  { label: "Mark-Up", accessor: (odc) => odcYesNoLabel(odc.markup), width: 100 },
  { label: "Apply Burden", accessor: (odc) => odcYesNoLabel(odc.applyBurden), width: 100 },
];

export const ODC_STATIC_COLUMNS_TOTAL_WIDTH = ODC_STATIC_COLUMNS.reduce(
  (total, column) => total + column.width,
  0,
);

// ODC weekly bucket sub-columns — Unburden Cost / Burden Cost only, no Revenue. Each pair totals
// WEEKLY_COLUMN_WIDTH so a week occupies the same width here as in Direct Labor, keeping weeks
// aligned when scrollLeft is synced across both tables.
export const ODC_WEEKLY_BUCKET_COLUMN_WIDTHS = {
  unburdenCost: WEEKLY_COLUMN_WIDTH / 2,
  burdenCost: WEEKLY_COLUMN_WIDTH / 2,
};
